import { render, staticRenderFns } from "./sch_enter.vue?vue&type=template&id=8089f8c4&scoped=true"
import script from "./sch_enter.vue?vue&type=script&lang=js"
export * from "./sch_enter.vue?vue&type=script&lang=js"
import style0 from "./sch_enter.vue?vue&type=style&index=0&id=8089f8c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8089f8c4",
  null
  
)

export default component.exports